export default {
  alarmas: [],
  error: false,
  errorMessage: [],
}
